import React from 'react';
import SocialNetworkLabel from 'components/SocialNetworkLabel';
import UserSocialNetwork from 'domain/UserSocialNetwork';
import SocialNetwork from 'domain/SocialNetwork';
import Grid from '@mui/material/Unstable_Grid2';

interface SocialNetworksBoxParams {
    customSocialNetworks: Array<UserSocialNetwork>
    availableSocialNetworks: Array<SocialNetwork>
}

export const SocialNetworksBox = ({ customSocialNetworks, availableSocialNetworks }: SocialNetworksBoxParams) => {

    return (
        <Grid container my={2}>
            {customSocialNetworks
                ?.slice()
                ?.sort((a, b) => {
                    if (!a.id && b.id) return -1;
                    if (!b.id && a.id) return 1;
                    return 0;
                })
                ?.map((sn) => {
                    const socialNetwork = sn.idSocialNetwork && !sn.id
                        ? availableSocialNetworks.find((asn) => asn.id === sn.idSocialNetwork)
                        : null;
                    const name = socialNetwork ? socialNetwork.name : sn.name;
                    return (
                        <Grid xs={6} sm={12} key={`${sn.id}-${sn.handle}`}>
                            <SocialNetworkLabel handle={sn.handle} name={name}/>
                        </Grid>
                    );
                })}
        </Grid>
    );
};